export class weightageapprovalModel {
  WeightageApprovalPendingListAPI: string;
  updateApprovalstatusAPI: string;
  GetWeightageCEODashboardListAPI: string;
  GetWeightageCEOConsecutivereportAPI: string;


}
